import { getDashboardUpcomingEvents } from '@simplywallst/services';
import { withAuth } from '@utilities/queries';
import { utcFormat } from 'd3-time-format';
import { ROUTE_COMPANY } from '@/constants/routes';

interface Event {
  canonicalUrl: ReducerAction;
  companyName: string;
  date: string;
  eventType: string;
  id: string;
  tickerSymbol: string;
  uniqueSymbol: string;
}

export const getDefault = (): Record<'earnings' | 'dividends', Event[]> => ({
  earnings: [],
  dividends: [],
});

// the router has zero respect for anchors :(
export const getCompanyRouteReducerAction = (
  canonicalUrl: string,
  anchor: string
): ReducerAction => {
  const url = canonicalUrl.split('/');
  return {
    type: ROUTE_COMPANY,
    payload: {
      isoCode2: url[2] || undefined,
      industry: url[3] || undefined,
      exchange_ticker: url[4] || undefined,
      companyname: url[5] || undefined,
      anchor,
    },
  };
};

export default async (): Promise<Record<string, Event[]> | undefined> => {
  try {
    const data = await withAuth(getDashboardUpcomingEvents);
    if (typeof data !== 'undefined') {
      const {
        data: {
          data: { earnings, dividends },
        },
      } = data;
      if (typeof earnings === 'undefined' || typeof dividends === 'undefined') {
        return;
      }
      const formatUTC = utcFormat('%b %d');
      return {
        earnings: earnings
          .sort((a, b) => a.date - b.date)
          .map((n) => ({
            canonicalUrl: getCompanyRouteReducerAction(n.canonical_url, 'past'),
            companyName: n.company,
            date: formatUTC(new Date(n.date)),
            eventType: 'earnings',
            id: n.id.toString(),
            tickerSymbol: n.ticker_symbol,
            uniqueSymbol: n.unique_symbol,
          })),
        dividends: dividends
          .sort((a, b) => a.date - b.date)
          .map((n) => ({
            canonicalUrl: getCompanyRouteReducerAction(
              n.canonical_url,
              'dividend'
            ),
            companyName: n.company,
            date: formatUTC(new Date(n.date)),
            eventType: 'earnings',
            id: n.id.toString(),
            tickerSymbol: n.ticker_symbol,
            uniqueSymbol: n.unique_symbol,
          })),
      };
    }
  } catch (error: any) {
    console.log(error.message);
  }
};
